import React, { useState } from "react";
import NavBar from "../components/layout/NavBar";
import ToolBarDash from "../components/layout/ToolBarDash";
import NovoEvento from "../components/eventos/NovoEvento";
import ListaEventos from "../components/eventos/ListaEventos";
import Footer from "../components/layout/Footer";
import WhatsAppButton from "../components/common/WhatsAppButton";

function Eventos() {
    const [novoEvento, setNovoEvento] = useState(true);
    const [listaEvento, setListaEvento] = useState(false);

    const handleMudaEstado = (novoEventoRecebido, listaEventoRecebida) => {
        setNovoEvento(novoEventoRecebido);
        setListaEvento(listaEventoRecebida);
    };

    return (
        <div className="min-h-screen flex flex-col justify-between bg-urb-dark text-white relative">
            <header>
                <NavBar />
                <ToolBarDash mudaEstado={handleMudaEstado} />
            </header>
            <main className="flex-grow max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
                {novoEvento && <NovoEvento />}
                {listaEvento && <ListaEventos />}
            </main>
            <Footer />
            <WhatsAppButton floating />
        </div>
    );
}

export default Eventos;